export function requireVar<T>(variable: T | null | undefined): NonNullable<T> {
	if (variable === undefined || variable === null) {
		throw new Error('Variable is undefined or null');
	}
	return variable;
}

